import React from 'react';

// 直接啟動線路圖配置
export const directStartConfig = {
    id: 0,
    name: '直接啟動',
    description: '最基本的馬達直接啟動控制電路',
    wireIds: [
        'wire-r-bus',          // R端子到STOP左端
        'wire-stopR-startL',   // STOP右端到中點
        'wire-stopR-startL2',  // 中點到START左端
        'wire-startR-motorL',  // START右端到中點
        'wire-startR-motorL2', // 中點到電機左端
        'wire-motorR-olL',     // 電機右端到95接點
        'wire-olR-t',          // 96接點到T端子
        'wire-branch-down',    // 自保持：垂直下 + 水平左段
        'wire-branch-up'       // 自保持：水平右段 + 垂直上回主線
    ]
};

// 直接啟動電路SVG渲染函數
export const renderDirectStart = (wcls, toggle) => (
    <>
        <text x="410" y="48" textAnchor="middle" className="diagram-title">直接啟動</text>
        <line x1="90" y1="80" x2="90" y2="420" className="bus" />
        <line x1="730" y1="80" x2="730" y2="420" className="bus" />
        <text x="90" y="70" textAnchor="middle" className="terminal-label">R</text>
        <text x="730" y="70" textAnchor="middle" className="terminal-label">T</text>

        <line x1="90" y1="160" x2="153" y2="160"
            className={wcls('wire-r-bus')}
            onClick={() => toggle('wire-r-bus')} />

        <text x="173" y="130" textAnchor="middle" className="switch-label">off</text>
        <circle cx="160" cy="160" r="6" className="terminal-dot" />
        <circle cx="190" cy="160" r="6" className="terminal-dot" />
        <line x1="153" y1="168" x2="198" y2="168" className="contact-blade" />

        <line x1="197" y1="160" x2="237" y2="160"
            className={wcls('wire-stopR-startL')}
            onClick={() => toggle('wire-stopR-startL')} />

        <line x1="237" y1="160" x2="273" y2="160"
            className={wcls('wire-stopR-startL2')}
            onClick={() => toggle('wire-stopR-startL2')} />

        <text x="295" y="120" textAnchor="middle" className="switch-label">on</text>
        <circle cx="280" cy="160" r="6" className="terminal-dot" />
        <circle cx="310" cy="160" r="6" className="terminal-dot" />
        <line x1="275" y1="150" x2="315" y2="150" className="contact-blade" />

        <line x1="316" y1="160" x2="382" y2="160"
            className={wcls('wire-startR-motorL')}
            onClick={() => toggle('wire-startR-motorL')} />

        <line x1="382" y1="160" x2="422" y2="160"
            className={wcls('wire-startR-motorL2')}
            onClick={() => toggle('wire-startR-motorL2')} />

        <circle cx="450" cy="160" r="28" className="motor" />
        <text x="450" y="166" textAnchor="middle" className="motor-label">M</text>

        <line x1="478" y1="160" x2="554" y2="160"
            className={wcls('wire-motorR-olL')}
            onClick={() => toggle('wire-motorR-olL')} />

        <circle cx="560" cy="160" r="6" className="terminal-dot" />
        <text x="560" y="140" textAnchor="middle" className="contact-label">95</text>
        <circle cx="610" cy="160" r="6" className="terminal-dot" />
        <text x="610" y="140" textAnchor="middle" className="contact-label">96</text>

        <line x1="564" y1="154" x2="606" y2="166" className="contact-blade" />
        <line x1="564" y1="166" x2="606" y2="154" className="contact-blade" />

        <line x1="616" y1="160" x2="730" y2="160"
            className={wcls('wire-olR-t')}
            onClick={() => toggle('wire-olR-t')} />

        <line x1="235" y1="160" x2="235" y2="240"
            className={wcls('wire-branch-down')}
            onClick={() => toggle('wire-branch-down')} />

        {/* 自保持接點（NO 輔助，兩垂直短線） */}
        {/* 垂直下 + 水平左 合併 */}
        <line x1="233" y1="240" x2="300" y2="240"
            className={wcls('wire-branch-down')}
            onClick={() => toggle('wire-branch-down')} />

        {/* 水平右 + 垂直上 合併 */}
        <line x1="316" y1="240" x2="382" y2="240"
            className={wcls('wire-branch-up')}
            onClick={() => toggle('wire-branch-up')} />
        {/* 中間畫 NO 輔助接點的兩條立柱（裝飾） */}
        <line x1="300" y1="230" x2="300" y2="250" className="aux-pill" />
        <line x1="315" y1="230" x2="315" y2="250" className="aux-pill" />

        {/* 從分支上來回到主幹（接到 M 左側）（可點） - 水平右 + 垂直上 合併 */}
        <line x1="380" y1="240" x2="380" y2="160"
            className={wcls('wire-branch-up')}
            onClick={() => toggle('wire-branch-up')} />
    </>
);
